import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  InputBase,
  Button,
  Menu,
  MenuItem,
  CircularProgress,
  Divider,
  Snackbar
} from "@material-ui/core";
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import SearchIcon from "@material-ui/icons/Search";
import { makeStyles } from "@material-ui/core/styles";
import Table from "react-bootstrap/Table";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { Link } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { DeleteProgram, GenerateConnectLink, GetPrgrams, LoginConnectAccount, UploadCSV, UpdateOrgVisibility, GetOgranizationByID } from "../api";
import moment from 'moment';
import { useHistory } from 'react-router-dom'
import MuiAlert from "@material-ui/lab/Alert";
import { Alert, AlertTitle } from "@material-ui/lab";
import {
   FormControl, InputLabel, Switch, FormControlLabel
} from '@material-ui/core'
import * as XLSX from 'xlsx';
import Select from 'react-select';
import PreviewProgram from "./previewProgram";

const useStyles = makeStyles((theme) => ({
  main: {
    background: "#E8F0F2",
    padding: "10px",
    borderTopRightRadius: "8px",
    borderTopLeftRadius: "8px",
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    // backgroundColor: alpha(theme.palette.common.white, 0.15),
    // "&:hover": {
    //   backgroundColor: alpha(theme.palette.common.white, 0.25),
    // },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
    background: "#fff",
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    // color: "red",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "330px !important",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
}));

function AlertComponent(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const TableComponent = () => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event, id) => {
    setAnchorEl(event.currentTarget);
    setOpen(id)
  };

  const [open, setOpen] = React.useState(null);

  const handleClose = () => {
    setAnchorEl(null);
    setOpen(null);
  };

  const [pending, setPending] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [search, setSearch] = React.useState('');
  const [limit, setLimit] = React.useState(1000);
  const [page, setPage] = React.useState(0);

  const [deleteId, setDeleteId] = React.useState(null);
  const [pendingDelete, setPendingDelete] = React.useState(false);

  const [query, setQuery] = React.useState('');

  const { user } = useSelector(({ auth }) => auth, shallowEqual);

  const org = useSelector((data) => data.org.data, shallowEqual);

  const [snackBarText, setSnackBarText] = React.useState("");
  const [snackBarOpen, setSnackBarOpen] = React.useState(false);
  const [snackBarVariant, setSnackBarVariant] = React.useState("success");

  const history = useHistory();

  const [openPopup, setOpenPopup] = useState(false);
  const [file, setFile] = useState(null);

  const [columns, setColumns] = useState([]);
  const [mapping, setMapping] = useState({});
  const all_fields = [
      "industry_id",
      "industry_name",
      "program_code",
      "program_title",
      "program_subtitle",
      "program_image_url",
      "estimated_time",
      "learning_model",
      "course_type",
      "soc_code",
      "total_cost",
      "program_description",
      "program_objective",
      "general_requirements",
      "technical_requirements",
      "course_materials",
      "program_session",
      "start_date",
      "end_date",
      "drop_date",
      "add_date",
      "terms_date",
      "additional_costs",
      "career_opportunities",
      "program_outcomes",
      "instructors",
      // "program_status",
      // "public"
  ];
  const [excelData, setExcelData] = useState([]);

  const [openMapPopup, setOpenMapPopup] = useState(false);

  const [processing, setProcessing] = useState(false);

  const [isReady, setIsReady] = useState(false);

  const [sheetList, setSheetList] = useState([]);
  const [selectedSheet, setSelectedSheet] = useState(null);
  const [isSheetSelected, setIsSheetSelected] = useState(false);


  const [isPrivate, setIsPrivate] = useState(false);
  const [hide, setHide] = useState(false);
  const [orgName, setOrgName] = useState(false);
  const [pendingVisibility, setPendingVisibility] = useState(false);

  const [pendingLogin, setPendingLogin] = useState(false);


  const handleClickOpen = () => {
    if(org.charges_enabled == false && org.payment_handling == "stripe_connect"){
      setSnackBarVariant("error");
      setSnackBarText("To add a new program, you need to complete your Stripe Connect setup. This is necessary to start receiving payments. Please complete the setup process now to proceed.");
      setSnackBarOpen(true);
      return ;
    }
    setOpenPopup(true);
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
    setFile(null); // Reset file on close
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  // const handleUpload = async () => {
  //   let formData = new FormData();
  //   formData.append("csvFile", file);
  //   formData.append("org", user.organization);

  //   try{
  //     setSnackBarText("Uploading you will be notify onces it done");
  //     setSnackBarVariant("success");
  //     setSnackBarOpen(true);
  //     handleClosePopup();
  //     let res = await UploadCSV(formData);
  //     setSnackBarText(res.data.message);
  //     setSnackBarVariant("success");
  //     setSnackBarOpen(true);
  //     handleGetPrograms();
  //   }catch(ex){
  //     let error = ex.response ? ex.response.data.message : ex.message;
  //     setSnackBarText(error);
  //     setSnackBarVariant("error");
  //     setSnackBarOpen(true);
  //     // alert(error);
  //   }

  //   // Handle the file upload logic here
  //   // alert("Uploading file. You can keep your working it may take sometime");
  //   // console.log('Uploading file:', file);
  // };

  const handleUpload = () => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const binaryStr = e.target.result;
      const workbook = XLSX.read(binaryStr, { type: 'binary' });

      setSheetList(workbook.SheetNames);

      // Assuming data is in the first sheet
      // const sheetName = workbook.SheetNames[0];
      // const worksheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1 });

      // const tmp_columns = worksheet[0]; // Get header row (first row)
      // const data = worksheet.slice(1); // Get data rows (excluding header)

      // setExcelData(data);

      // setColumns(tmp_columns);

      // // Initialize column mapping
      // const initialMapping = {};
      // all_fields.forEach((key) => {
      //   initialMapping[key] = tmp_columns.includes(key) ? key : '';
      // });

      // setMapping(initialMapping);
    };

    if (file) {
      reader.readAsBinaryString(file);
      setOpenMapPopup(true);
    }
  }

  const handleSheet = () => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const binaryStr = e.target.result;
      const workbook = XLSX.read(binaryStr, { type: 'binary' });

      // Assuming data is in the first sheet
      const sheetName = selectedSheet;
      const worksheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1 });

      if(worksheet.length == 0){
        alert('No data in selected file');
        return ;
      }

      const tmp_columns = worksheet[0]; // Get header row (first row)
      const data = worksheet.slice(1); // Get data rows (excluding header)

      setExcelData(data);

      setColumns(tmp_columns);

      // Initialize column mapping
      const initialMapping = {};
      all_fields.forEach((key) => {
        initialMapping[key] = tmp_columns.includes(key) ? key : '';
      });

      setMapping(initialMapping);
    };

    if (file) {
      reader.readAsBinaryString(file);
      setOpenMapPopup(true);
    }
  }

  const handleMappingChange = (field, value) => {
    setMapping((prev) => ({
      ...prev,
      [field]: value && value.value ? value.value : "",
    }));
  };

  const handleSubmitMappedFile = () => {
    if(!isSheetSelected){
      if(selectedSheet == null){
        alert('Please select sheet');
        return ;
      }
      setIsSheetSelected(true);
      handleSheet();
      return ;
    }
    setProcessing(true);
    const mappedData = [];

    // Iterate over each row in the Excel data
    excelData.forEach((row) => {
      const mappedRow = {};

      // Iterate over each field in all_fields array
      all_fields.forEach((field) => {
        // Check if a valid mapping exists for this field
        const mappedColumn = mapping[field];

        // Find the index of the mapped column in the columns array
        const columnIndex = columns.indexOf(mappedColumn);

        // If the columnIndex is valid (exists in the row), map the value
        if (columnIndex > -1) {
          mappedRow[field] = row[columnIndex];  // Assign the corresponding value
        } else {
          mappedRow[field] = '';  // If not found, set it as empty or handle it differently
        }
      });

      // Add the mapped row to the mappedData array
      mappedData.push(mappedRow);
    });

    setExcelData(mappedData);
    setProcessing(false);
    setIsReady(true);
    setFile(null);
    setOpenMapPopup(false);
    setOpenPopup(false);
  }


  useEffect(()=>{
    console.log(mapping);
  }, [mapping])

  const handleSnackBarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackBarOpen(false);
  };

  React.useEffect(() => {
    const handler = setTimeout(() => {
      setSearch(query);
    }, 300); // 300ms debounce delay

    // Cleanup the timeout on component unmount or when query changes
    return () => {
      clearTimeout(handler);
    };
  }, [query]);

  React.useEffect(() => {
    handleGetPrograms();
  }, [search]);

  React.useEffect(()=>{
    if(!pending){
      handleGetPrograms();
    }
  }, [])

  React.useEffect(()=>{
    const fetchHide = async () => {
      try {
        let res = await GetOgranizationByID(user.organization);
        setHide(res.data.data.hide || false);
      } catch(ex) {
        console.log(ex);
      }
    }
    if(user.organization) fetchHide();
  }, [])

  const handleGetPrograms = async () => {
    setPending(true);
    try{
      console.log(user);
      let response = await GetPrgrams(user.organization, search, limit, page);
      setData(response.data.data.programs);
      setIsPrivate(response.data.data.isPrivate);
      setOrgName(response.data.data.org.slug)
      // console.log(response.data.data);
    }catch(ex){
      console.log(ex);
    }finally{
      setPending(false);
    }
  }

  const handleDelete = async () => { 
    setPendingDelete(true);
    try{
      let res = await DeleteProgram(deleteId);
      setDeleteId(null);
      handleGetPrograms();
      setAnchorEl(null);
    }catch(ex){
      console.log(ex);
    }finally{
      setPendingDelete(false);
    }
  }

  const handleEdit = (id) => {
    history.push(`/programs/edit-program/${id}`);
  }
  const [pendingCompleteAccount, setPendingCompleteAccount] = useState(false);
  const handleCompleteAccout = async () => {
    setPendingCompleteAccount(true);
    try{
      let res = await GenerateConnectLink(org._id);
      window.location.href = res.data.url;
      return ;
    }catch(ex){
      let error = ex.response ? ex.response.data.message : ex.message;
      alert(error)
      setPendingCompleteAccount(false);
    }

  }

  const handleLogin = async () => {
    setPendingLogin(true);
    try{
      let res = await LoginConnectAccount(org._id);
      let anchar = document.createElement("a");
      anchar.href = res.data.data.url;
      anchar.target = "_blank";
      anchar.click();
    }catch(ex){
      let error = ex.response ? ex.response.data.message : ex.message;
      setSnackBarVariant("error");
      setSnackBarText(error);
      setSnackBarOpen(true)
    }finally{
      setPendingLogin(false)
    }
  }

  const handleToggleVisibility = async () => {
    const newValue = !hide;
    setPendingVisibility(true);
    try {
      await UpdateOrgVisibility(user.organization, newValue);
      setHide(newValue);
    } catch (ex) {
      let error = ex.response ? ex.response.data.message : ex.message;
      setSnackBarVariant("error");
      setSnackBarText(error);
      setSnackBarOpen(true);
    } finally {
      setPendingVisibility(false);
    }
  };

  return (
    <div className="mt-10">
      { org.charges_enabled && org.stripe_connect_id && org.payment_handling == "stripe_connect" &&  
      <div style={{ display: "flex", justifyContent: "flex-end", width: "100%", marginBottom: "10px" }}>
        <Button
          variant="contained"
          color="primary"
          style={{ marginLeft: "auto" }}
          onClick={handleLogin}
          disabled={pendingLogin}
        >
          {pendingLogin ? <CircularProgress
                size="20px"
                style={{ color: "#3783e7" }}
              /> : "Open Stripe Dashboard"}
        </Button>
      </div>
      }
      {org.charges_enabled == false && org.payment_handling == "stripe_connect" && <Alert className="action-required" severity="info" style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
          <div>
            <AlertTitle>Action Required</AlertTitle>
            To start receiving payments, complete your Stripe Connect setup:
          </div>
          <Button
            variant="contained"
            color="primary"
            style={{ marginLeft: "auto" }}
            onClick={handleCompleteAccout}
            disabled={pendingCompleteAccount}
          >
            {pendingCompleteAccount ? <CircularProgress
                  size="20px"
                  style={{ color: "#3783e7" }}
                /> : "Complete Stripe Setup"}
          </Button>
        </div>
      </Alert>}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
        <h6 style={{ marginBottom: 0 }}>
          {isPrivate && "Private"} Organization Link: <a target="_blank" href={`https://training.workforcefortune.com/${encodeURIComponent(orgName)}`}>https://training.workforcefortune.com/{encodeURIComponent(orgName)}</a>
        </h6>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Typography variant="caption" style={{ color: '#888' }}>
            Hide programs when you are no longer accepting students.
          </Typography>
          {pendingVisibility
            ? <CircularProgress size={20} style={{ color: '#3783e7' }} />
            : <Switch
                checked={hide}
                onChange={handleToggleVisibility}
                color="primary"
              />
          }
        </div>
      </div>
      <Box className={classes.main}>
        <Grid container alignItems="center">
          <Typography variant="h4">Career Training Programs</Typography>
          <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <InputBase
              placeholder="Search…"
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              inputProps={{ "aria-label": "search" }}
              onChange={(e)=>{setQuery(e.target.value)}}
              value={query}
            />
          </div>
          <Box spacing={5}>
            <Button variant="contained" onClick={handleClickOpen} color="primary">
              {/* <Link className="text-white" to="/programs/add-program"> */}
                Add New Programs
              {/* </Link> */}
            </Button>
            {/* <Button variant="contained" color="primary" className="ml-5">
              Edit My Details
            </Button>
            <Button variant="contained" color="primary" className="ml-5">
              Sales History
            </Button> */}
          </Box>
        </Grid>
      </Box>
      
      <div className="border mt-1">
        <Table hover size="sm">
          <thead style={{ background: "#F1F5F8" }}>
            <tr>
              <th>Title</th>
              <th>Industry</th>
              <th>Cost</th>
              <th>Program Status</th>
              <th>Last Updated</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {!pending && data.length > 0 && data.map((item, index)=>{
              return (
                <tr key={index}>
                  <td>{item.program_title}</td>
                  <td>{item.industry_name}</td>
                  <td>${item.total_cost}</td>
                  <td>{item.program_status ? 'Enabled': 'Disabled'}</td>
                  <td>{moment(item.updated_at).format("MM/DD/YYYY")}</td>
                  <td>
                    <Button
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      onClick={(event)=>{handleClick(event, item._id)}}
                    >
                      <MoreVertIcon />
                    </Button>
                    <Menu
                      id="simple-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={open == item._id}
                      // open={Boolean(anchorEl)}
                      onClose={handleClose}
                    >
                      <MenuItem onClick={()=>{handleEdit(item.slug)}}>
                        Edit Program Details
                      </MenuItem>
                      {/* <MenuItem onClick={handleClose}>
                        Edit Program Status
                      </MenuItem> */}
                      <MenuItem onClick={()=>{setDeleteId(item._id)}}>
                        Delete Program
                      </MenuItem>
                    </Menu>
                  </td>
                </tr>
              ); 
            })}
              {pending && <tr>
                <td colSpan={6} align="center">
                <CircularProgress
                  size="20px"
                  style={{ color: "#3783e7" }}
                />
                </td>
              </tr>}
              {!pending && data.length == 0 && <tr><td align="center" colSpan={6}>No Pragrams Available</td></tr>}
          </tbody>
        </Table>
      </div>
      <Dialog
        open={deleteId ? true : false}
        onClose={()=>{setDeleteId(null)}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          Are you sure? You want to delete program ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button disabled={pendingDelete} onClick={()=>{setDeleteId(null)}} color="primary">
            Cancle
          </Button>
          <Button onClick={handleDelete} disabled={pendingDelete} style={{color: "#bb2124"}} autoFocus>
            {pendingDelete ? <CircularProgress
                  size="20px"
                  style={{ color: "#bb2124" }}
                /> : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openPopup} onClose={handleClosePopup} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Add Program</DialogTitle>
        <DialogContent>
          <Button variant="contained" color="primary" fullWidth>
              <Link className="text-white" to="/programs/add-program">
                Add New Program Manually
              </Link>
          </Button>
          {/* <Divider style={{ margin: '20px 0' }}></Divider> */}
          <h1 style={{ textAlign: "center", marginTop: "5px", marginBottom: "5px" }}>OR</h1>
          <Typography variant="body1" align="center">
            Upload Excel File
          </Typography>
          <input
            accept=".xlsx"
            style={{ display: 'none' }}
            id="upload-file"
            type="file"
            onChange={handleFileChange}
          />
          <label htmlFor="upload-file" style={{ display: "block" }}>
          <Button
              variant="outlined"
              color="primary"
              component="span"
              startIcon={<CloudUploadIcon />}
              fullWidth
            >
              Choose Excel File
            </Button>
            
          </label>
          {/* <Button
              variant="outlined"
              color="primary"
              component="span"
              // startIcon={<CloudUploadIcon />}
              disabled={true}
              fullWidth
            >
              Coming Soon

            </Button> */}
          {/* <a href="https://chat-attachements.s3.amazonaws.com/sample_file_1725354154204.csv" download={true}>Download Sample</a> */}
          {file && (
            <Button
              variant="contained"
              color="secondary"
              onClick={handleUpload}
              fullWidth
              style={{ marginTop: '20px' }}
            >
              Proccess {file.name}
            </Button>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePopup} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackBarOpen}
        autoHideDuration={5000}
        onClose={handleSnackBarClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <AlertComponent
          onClose={handleSnackBarClose}
          style={{
            fontSize: "16px",
            backgroundColor: snackBarVariant === "error" ? "red" : "",
          }}
          severity={snackBarVariant}
        >
          {snackBarText}
        </AlertComponent>
      </Snackbar>
      <Dialog open={openMapPopup} onClose={()=>{
        setFile(null);
        setOpenMapPopup(false);
      }} fullWidth maxWidth="md">
      <DialogTitle>Map Excel Columns</DialogTitle>
      <DialogContent>
        {!isSheetSelected && (
          <Grid container spacing={3} style={{minHeight: '50vh'}}>
            <Grid item xs={12} sm={4}>
                <label>Select Sheet</label>
                <Select
                  placeholder={'Select Sheet'}
                  // value={}
                  value={selectedSheet ? {value: selectedSheet, label: selectedSheet}:null}
                  onChange={(value)=>{
                    if(!value){
                      setIsSheetSelected(false)
                    }else{
                      console.log(value);
                      setSelectedSheet(value.value);
                    }
                  }}
                  options={sheetList.map((col) => ({
                    value: col,
                    label: col
                  }))}
                  isClearable
                />
              </Grid>
          </Grid>
        )}
        {excelData.length > 0 && isSheetSelected && (
             <Grid container spacing={3}>
              {all_fields.map((fieldKey, index) => (
              <Grid item xs={12} sm={4} key={index}>
                  <Select
                    placeholder={fieldKey}
                    // value={}
                    value={mapping[fieldKey] ? { value: mapping[fieldKey], label: mapping[fieldKey] } : null}
                    onChange={(selectedOption) => handleMappingChange(fieldKey, selectedOption)}
                    options={columns.map((col) => ({
                      value: col,
                      label: col
                    }))}
                    isClearable
                  />
                </Grid>
              ))}
            </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={()=>{
          setFile(null);
          setOpenMapPopup(false);
          setSelectedSheet(null);
          setIsSheetSelected(false);
        }} color="primary">
          Cancel
        </Button>
        <Button disabled={processing} onClick={handleSubmitMappedFile} color="primary">
          {processing ? <CircularProgress
                  size="20px"
                  style={{ color: "#bb2124" }}
                /> : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
    <Dialog open={isReady} onClose={()=>{
        setFile(null);
        setOpenMapPopup(false);
        setOpenPopup(false);
        setIsSheetSelected(false);
        setSelectedSheet(null);
      }} fullWidth maxWidth="md">
      <DialogTitle>Preview Entry</DialogTitle>
      <DialogContent>
        {isReady && <PreviewProgram excelData={excelData} setOpen={setIsReady} />}
      </DialogContent>
      {/* <DialogActions>
        <Button onClick={()=>{
          setFile(null);
          setOpenMapPopup(false);
        }} color="primary">
          Cancel
        </Button>
        <Button disabled={processing} onClick={handleSubmitMappedFile} color="primary">
          Submit
          {processing ? <CircularProgress
                  size="20px"
                  style={{ color: "#bb2124" }}
                /> : "Submit"}
        </Button>
      </DialogActions> */}
    </Dialog>
    </div>
  );
};

export default TableComponent;
